{
  "title": "Groupes",
  "subtitle": "Reflétés depuis l’annuaire du client. Définissez des remplissages pour les attributs vides, une priorité si quelqu’un est dans plusieurs groupes, et une signature optionnelle pour les membres sans règle opérateur.",
  "searchPlaceholder": "Rechercher des groupes",
  "colGroup": "Groupe",
  "colMembers": "Membres",
  "colPriority": "Priorité",
  "colOverrides": "Remplacements",
  "colSignature": "Signature",
  "emptySearch": "Aucun groupe ne correspond à cette recherche.",
  "emptyNone": "Aucun groupe n’a encore été synchronisé. Connectez un annuaire dans Aperçu ou Intégration.",
  "priority": "Priorité",
  "signatureTemplate": "Signature du groupe",
  "noSignature": "Aucune (passer)",
  "overrides": "Remplacements d’attributs",
  "save": "Enregistrer le groupe",
  "saved": "Groupe enregistré.",
  "saveError": "Impossible d’enregistrer ce groupe.",
  "none": "Aucune",
  "count": "{{count}}",
  "groupFallback": "Groupe",
  "fieldsCount": "{{count}} champ",
  "fieldsCount_other": "{{count}} champs",
  "signatureSet": "Définie",
  "overridePriorityTitle": "Priorité de remplacement",
  "overridePriorityHint": "Lorsqu’une personne est dans plusieurs groupes qui remplissent le même champ vide, la priorité la plus élevée l’emporte.",
  "savePriority": "Enregistrer la priorité",
  "prioritySaved": "Priorité enregistrée.",
  "groupSignatureTitle": "Signature du groupe",
  "groupSignatureHint": "Utilisée lorsqu’aucune règle opérateur ne correspond et que la personne n’a pas de signature personnalisée. Perd face aux Règles ; bat la valeur par défaut du locataire.",
  "publishTemplateFirst": "Publiez un modèle avant d’attribuer une signature de groupe.",
  "newMessages": "Nouveaux messages",
  "replies": "Réponses",
  "sameAsNew": "Identique au nouveau",
  "saveSignature": "Enregistrer la signature",
  "signatureSaved": "Signature du groupe enregistrée.",
  "signatureCleared": "Signature du groupe effacée.",
  "fieldFillsTitle": "Remplissages de champs",
  "fieldFillsSaved": "Remplissages de champs enregistrés.",
  "membersTitle": "Membres",
  "membersHint": "L’appartenance est synchronisée depuis l’annuaire, y compris les groupes imbriqués.",
  "noMembers": "Aucun membre synchronisé pour l’instant.",
  "viaNestedGroup": "via un groupe imbriqué",
  "couldNotSave": "Impossible d’enregistrer."
}
